import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { EXTERNAL_CONNECTION_CONFIGS } from './config/externalConnectionConfigs';
import ExternalProductImportView from './ExternalProductImportView';
import ExternalProductDesignView from './ExternalProductDesignView';

const ExternalProductImportViews = () => {
  const { configRouteValue } = useParams();

  const config = EXTERNAL_CONNECTION_CONFIGS.find(
    (c) => c.routeValue === configRouteValue
  );

  return (
    config && (
      <Routes>
        <Route
          element={<ExternalProductDesignView config={config} />}
          path="/design"
        />
        <Route
          element={<ExternalProductImportView config={config} />}
          path="/"
        />
        <Route
          element={<Navigate replace to="/ecomExternalProduct" />}
          path="*"
        />
      </Routes>
    )
  );
};

export default ExternalProductImportViews;
